{
    "common": {
        "mon": "Mo",
        "tue": "Di",
        "wed": "Mi",
        "thu": "Do",
        "fri": "Fr",
        "sat": "Sa",
        "sun": "So",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mär",
        "apr": "Apr",        
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Dez",
        "january": "Januar",
        "february": "Februar",
        "march": "März",
        "april": "April",
        "may": "Mai",
        "june": "Juni",
        "july": "Juli",
        "august": "August", 
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "Dezember",
        "checkin": "Check-In",
        "checkout": "Check-Out",
        "room": "Zimmer",
        "rooms": "Zimmer",
        "adult": "Erwachsener",
        "adults": "Erwachsene",
        "edit": "Bearbeiten",
        "editCap": "BEARBEITEN",
        "delete":"Löschen",
        "deleteCap":"LÖSCHEN",
        "localTime": "Ortszeit",
        "back": "ZURÜCK",
        "home": "STARTSEITE",
        "yes": "JA",
        "no": "NEIN",
        "left": "Verbleibend",
        "hour": "Stunde",
        "hours": "Stunden",
        "night": "Nacht",
        "nights": "Nächte",
        "for": "für",
        "why": "Warum",
        "get": "Holen",
        "more": "Mehr",
        "agree": "ZUSTIMMEN",
        "disagree": "ABLEHNEN",
        "basedOn": "basierend auf",
        "error": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut",
        "error2": "Fehlgeschlagen, versuchen Sie es erneut!",
        "error3": "Ein Fehler ist aufgetreten!!",
        "error4": "Ein Fehler ist aufgetreten!! Bitte versuchen Sie es erneut",
        "error5": "Entschuldigung!! Ein Fehler ist aufgetreten. Bitte versuchen Sie es nach einiger Zeit erneut.",
        "hi": "Hallo",
        "to": "zu",
        "free": "Kostenlos",
        "per": "Pro",
        "at": "um",
        "day": "Tag",
        "days": "Tage",
        "time": "Zeit",
        "of": "von",
        "photo": "Foto",
        "photos": "Fotos",
        "done": "Fertig",
        "fullStay": "Vollständiger Aufenthalt",
        "date": "Datum",
        "and": "und",
        "bookingDetail": "Buchungsdetails",
        "Back": "Zurück",
        "Home": "Startseite"
    },
    "userPopup":{
        "myAccount": "Mein Konto",
        "welcome": "Willkommen",
        "user": "Benutzer",
        "findMyBookings": "MEINE BUCHUNGEN FINDEN",
        "viewProfile": "PROFIL ANZEIGEN",
        "makeAReservarion": "EINE BUCHUNG MACHEN",
        "logout": "ABMELDEN",
        "loginCap": "ANMELDEN",
        "login": "Anmelden",
        "invalidCredentials": "Ungültige Anmeldedaten",
        "invalidEmail": "Ungültige E-Mail",
        "passwordIsRequired": "Passwort ist erforderlich",
        "minChar8":"mindestens 8 Zeichen",
        "tooShort": "Zu kurz!",
        "tooLong": "Zu lang!",
        "required": "Erforderlich",
        "emailInvalid":"Geben Sie eine gültige E-Mail ein",
        "passwordInvalid":"Geben Sie ein gültiges Passwort ein",
        "phNumInvalid": "Telefonnummer ist nicht gültig",
        "signupCap": "REGISTRIEREN",
        "signup": "Registrieren",
        "verifyText":"Bestätigen Sie, dass Sie es sind",
        "verifyText2":"Wir haben einen Bestätigungscode an Ihre E-Mail gesendet",
        "verificationCode":"Bestätigungscode",
        "didNotReceiveEmail": "E-Mail nicht erhalten",
        "clickToResend": "Klicken Sie zum erneuten Senden",
        "verifyAndSignIn": "Bestätigen und anmelden",
        "otpSentSuccessfully": "OTP erfolgreich gesendet",
        "somethingWentWrong":  "Etwas ist schiefgegangen, bitte versuchen Sie es erneut",
        "otpError": "Bitte geben Sie eine gültige Nummer ein",
        "otpError2":"Bitte geben Sie nur Zahlen ein",
        "otpError3": "Falscher OTP, bitte versuchen Sie es erneut",
        "otpError4": "OTP abgelaufen, klicken Sie auf Erneut senden",
        "otpError5": "Bitte versuchen Sie es erneut",
        "forgetPassword": "Passwort vergessen",
        "submitError": "Benutzer existiert nicht!",
        "userExistError": "Benutzer existiert bereits",
        "checkYourEmail":  "Überprüfen Sie Ihre E-Mail",
        "passwordResetLinkSent": "Wir haben einen Passwort-Reset-Link an gesendet",
        "noWorriesResetInstructions": "Keine Sorge, wir senden Ihnen Reset-Anweisungen.",
        "enterYourEmail": "Geben Sie Ihre E-Mail ein",
        "resetMyPassword": "MEIN PASSWORT ZURÜCKSETZEN",
        "setANewPassword": "Neues Passwort festlegen",
        "newPassword": "Neues Passwort",
        "confirmPassword": "Passwort bestätigen",
        "confirmPasswordError": "Passwörter müssen übereinstimmen",
        "backToLogin": "Zurück zur Anmeldung",
        "dontHaveAccount": "Haben Sie kein Konto?",
        "alreadyHaveAccount": "Haben Sie bereits ein Konto?",
        "memberDiscount1": "Sie erhalten",
        "memberDiscount2": "Mitgliederrabatt für immer.",
        "discount1": "Verwalten Sie alle Ihre Buchungen von einem Ort aus.",
        "discount2": "Registrieren Sie sich für personalisierte Empfehlungen und maßgeschneiderte Erfahrungen!!",
        "discount3": "Treten Sie unserer Gemeinschaft glücklicher Gäste bei und beginnen Sie mit der Planung Ihres Aufenthalts.",
        "leftGridText1": "Verwalten Sie alle Ihre Buchungen von einem Ort aus",
        "leftGridText2": "Registrieren Sie sich für personalisierte Empfehlungen und maßgeschneiderte Erfahrungen!!",
        "leftGridText3": "Treten Sie unserer Gemeinschaft glücklicher Gäste bei und beginnen Sie mit der Planung Ihres Aufenthalts",
        "gridDiscountText1": "Mitgliederrabatt für",
        "gridDiscountText2": "ausgewählte Immobilien für immer",
        "gridDiscountText3": "Anmelden für eine maßgeschneiderte Erfahrung für immer",
        "gridDiscountText4": "Exklusive Mitgliedervorteile erhalten",
        "findBookingError": "Ihre E-Mail und Buchungs-ID stimmen nicht überein",
        "verifyAndConfirmBooking":"Buchung bestätigen und bestätigen",
        "confirmEmailText": "Wir haben einen Bestätigungscode an Ihre E-Mail-Adresse gesendet",
        "enterCodeText":"Bitte geben Sie den an Sie gesendeten Bestätigungscode ein",
        "didNotRecieveEmail": "E-Mail nicht erhalten?",
        "changeEmailText": "Klicken Sie hier, um die E-Mail-Adresse zu ändern",
        "verifyAndConfirm": "Bestätigen und bestätigen",
        "verified": "BESTÄTIGT",
        "bookingExpired": "Buchung abgelaufen",
        "bookingExpiredText": "Es tut uns leid, die Buchungs-ID, die Sie verwenden, ist abgelaufen",
        "backToFindingBooking": "Zurück zur Buchungssuche",
        "findMyBooking": "Meine Buchung finden",
        "bookingEmail": "Buchungs-E-Mail",
        "reservationId": "Buchungs-ID",
        "findBooking": "BUCHUNG FINDEN",
        "abandonmentCartDoneText1": "Vielen Dank!",
        "abandonmentCartDoneText2":"Ihre Warenkorbdetails wurden an die E-Mail gesendet. Setzen Sie Ihre Buchung jederzeit fort.",
        "Recommended Currencies": "Empfohlene Währungen",
        "All currencies": "Alle Währungen",
        "thisIsRequiredField": "Dies ist ein erforderliches Feld"
    },
    "widget":{
        "destination": "Ziel",
        "enterDestination": "Ziel eingeben",
        "guests": "Gäste",
        "nationality": "Nationalität",
        "selectNationality": "Nationalität auswählen",
        "nationalityIsRequired": "Nationalität ist erforderlich",
        "selectedRate": "Sonderpreis",
        "search": "Suchen",
        "ages": "Alter",
        "orAbove": "Oder älter",
        "child": "Kind",
        "children": "Kinder",
        "addAnotherRoom": "Weiteres Zimmer hinzufügen",
        "removeRoom": "Zimmer entfernen",
        "property": "Immobilie",
        "city": "Stadt",
        "country": "Land",
        "bookNow": "Jetzt buchen",
        "overnightStay": "Übernachtungsaufenthalt",
        "dayUse": "Tagesnutzung",
        "destinationIsRequired": "Ziel ist erforderlich",
        "checkInIsRequired": "Check-In-Datum ist erforderlich",
        "checkOutIsRequired": "Check-Out-Datum ist erforderlich",
        "noLocationFound": "Kein Standort gefunden",
        "soldOut": "Ausverkauft",
        "highDemand": "Hohe Nachfrage",
        "dates": "Daten",
        "allRates": "Alle Tarife sind in",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Auschecken am selben Tag"
    },
    "promotion": {
        "headingText": "Wichtige Informationen für",
        "regularRate": "Keine",
        "seniorCitizen": "Senioren-Tarif",
        "agencyRate": "Agentur-Tarif",
        "caaRate": "CAA/AAA-Tarif",
        "corporateRate": "Firmen-Tarif",
        "governmentRate": "Regierungs-/Militär-Tarif",
        "promotionalSpecialRate": "Promotions-/Sonder-Tarif",
        "regularRateDescription": "Keine Promotion angewendet.",
        "seniorCitizenRateDescription": "Dies ist ein vergünstigter Hotel-Tarif, der umfassend für ältere Erwachsene verfügbar ist, typischerweise 60 Jahre oder älter.",
        "agencyRateDescription": "Dies ist ein vergünstigter Hotel-Tarif, der angeboten wird und nur über bestimmte Reisebüros zugänglich ist, um Partnerschaft und Zusammenarbeit zu fördern.",
        "caaRateDescription": "Dies ist ein spezieller Hotel-Tarif, der AAA- oder CAA-Mitgliedern für exklusive Einsparungen angeboten wird.",
        "corporateRateDescription": "Dies ist ein vergünstigter Hotel-Tarif, der auf Geschäftsreisende ausgedehnt wird, typischerweise zwischen dem Hotel und der Unternehmenseinheit ausgehandelt.",
        "governmentRateDescription": "Dieser Tarifplan bietet spezielle Rabatte für Regierungs-/Militärpersonal für die Buchung eines Hotelzimmers.",
        "contentSeniorCitizen": "Geburtsurkunde ist bei der Anreise obligatorisch. Wenn keine relevante ID vorgelegt wird, werden die geltenden Tarife berechnet.",
        "contentAgencyRate": "Stellen Sie sicher, dass Sie Ihre Buchungsbestätigung und ID-Nachweis bei der Ankunft haben. Wenn diese nicht vorgelegt werden, werden Standard-Tarife angewendet.",
        "contentPromotionalSpecialRate": "Dies ist ein vergünstigter Hotel-Tarif, der für eine begrenzte Zeit angeboten wird, oft an bestimmte Veranstaltungen, Jahreszeiten oder Marketing-Kampagnen gebunden.",
        "contentCaaRate": "Bitte stellen Sie sicher, dass Sie Ihre CAA-Mitgliedskarte oder relevante Identifikation bei der Anreise haben. Wenn keine relevante ID vorgelegt wird, werden die geltenden Tarife berechnet.",
        "contentCorporateRate": "Nachweis der Firmen-ID oder andere offizielle Dokumentation ist bei der Anreise erforderlich. Wenn kein relevanter Nachweis vorgelegt wird, werden die geltenden Tarife berechnet.",
        "contentGovernmentRate": "Gültige Regierungs- oder Militär-ID muss bei der Anreise vorgelegt werden. Wenn die erforderliche Identifikation nicht bereitgestellt wird, werden Gebühren zum Standard-Tarif berechnet.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "ANWENDEN",
        "Offer Code": "Angebotscode",
        "Agency Code": "Agenturcode",
        "Corporate Code": "Firmencode",
        "All-Access Rate": "All-Access-Tarif",
        "errorCode": "Dieser Code ist nicht gültig"
    }
} 